module.exports = __webpack_public_path__ + "static/media/pic1.e877f507.jpg";